// src/components/Customers.js
import React from 'react';
import './Customers.css';

function Customers() {
  return (
    <section className="customers" id="customers">
      <div className="customers-container">
        <h2>CUSTOMERS</h2>
        
        <div className="customers-grid">
          <div className="customer-logo">
            <img src="/images/caf.png" alt="CAF" />
          </div>
          
          <div className="customer-logo">
            <img src="/images/crabi.png" alt="Crabi" />
          </div>
          
          <div className="customer-logo">
            <img src="/images/unimet.png" alt="Universidad Metropolitana" className="logo-white" />
          </div>
          
          <div className="customer-logo">
            <img src="/images/barako.png" alt="Barako" />
          </div>
          
          <div className="customer-logo">
            <img src="/images/banco_activo.svg" alt="Banco Activo" className="logo-white" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Customers;

